import { useState } from 'react';
import { toast } from 'react-toastify';
import { Markdown } from '~/components/chat/Markdown';
import { fetchStreamedText } from '~/lib/.client/fetch';
import { EnhancerError } from '~/lib/errors';

export function usePromptEnhancer() {
  const [enhancingPrompt, setEnhancingPrompt] = useState(false);
  const [promptEnhanced, setPromptEnhanced] = useState(false);

  const resetEnhancer = () => {
    setEnhancingPrompt(false);
    setPromptEnhanced(false);
  };

  const enhancePrompt = async (
    originalInput: string,
    setInput: (value: string) => void,
    onComplete: (args: { finalInput: string; originalInput: string }) => void,
  ) => {
    setEnhancingPrompt(true);
    setPromptEnhanced(false);

    try {
      const finalInput = await fetchStreamedText('/api/enhancer', {
        method: 'POST',
        body: JSON.stringify({
          message: originalInput,
        }),
        errorParser: EnhancerError,
        onTextStream: setInput,
      });

      onComplete({ finalInput, originalInput });
    } catch (error) {
      setInput(originalInput);

      const errorMessage = error instanceof Error ? error.message : 'An unknown error occured';

      toast.error(<Markdown html>{errorMessage}</Markdown>);
    } finally {
      setEnhancingPrompt(false);
      setPromptEnhanced(true);
    }
  };

  return { enhancingPrompt, promptEnhanced, enhancePrompt, resetEnhancer };
}
